import { Paragraph } from './paragraph.js'

export * from './paragraph.js'

export default Paragraph
